import { Box } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaButton, RanaModal } from "@nens/ranalib";
import { removeNullUndefined } from "@nens/shared-utils";

import { usePublicationStore } from "../../../store/store";
import { PublicationFilesTable } from "../../map-layer-list";
import { SelectedFileOrLayer } from "../../map-layers";

export function AddStudyAreaModal({ close }: { close: () => void }) {
  const intl = useIntl();
  const setStudyAreaForCurrentMap = usePublicationStore((state) => state.setStudyAreaForCurrentMap);
  const [selectedItem, setSelectedItem] = useState<SelectedFileOrLayer | null>(null);

  const handleSelectionChange = useCallback((items: SelectedFileOrLayer[]) => {
    setSelectedItem(items[items.length - 1]);
  }, []);

  const doAddStudyArea = useCallback(() => {
    if (selectedItem) {
      setStudyAreaForCurrentMap(selectedItem.file, selectedItem.name, selectedItem.layerInFile);
      close();
    }
  }, [close, selectedItem, setStudyAreaForCurrentMap]);

  return (
    <RanaModal
      isOpen
      onClose={close}
      topBar={intl.formatMessage({
        id: "publication.map.add_study_area_modal.title",
        defaultMessage: "Add new study area",
      })}
      buttons={[
        <RanaButton key="cancel" variant="secondary" onClick={close}>
          <FormattedMessage
            id="publication.map.add_study_area_modal.cancel"
            defaultMessage="Cancel"
          />
        </RanaButton>,
        <RanaButton
          key="change"
          variant="primary"
          isDisabled={!selectedItem}
          onClick={doAddStudyArea}
        >
          <FormattedMessage
            id="publication.map.add_study_area_modal.add"
            defaultMessage="Add study area"
          />
        </RanaButton>,
      ]}
    >
      <Box pb={4}>
        <FormattedMessage
          id="publication.map.add_study_area_modal.instructions"
          defaultMessage="Select one study area layer from a publication file."
        />
      </Box>

      <PublicationFilesTable
        selectedItems={removeNullUndefined([selectedItem])}
        onSelectionChange={handleSelectionChange}
        mode="study-area"
      />
    </RanaModal>
  );
}
